import pageToPrint from '@/helpers/enums/pageToPrint'

// Opt-in guard for the routes showing the VCR, blocked for a dealer whose settings hide it.
export const showsVcr = (to) => {
  if (!to.meta?.showsVcr) return false

  const vcrParams = to.meta.showsVcrParams
  if (!vcrParams) return true

  return Object.entries(vcrParams).every(([param, value]) => to.params[param] === value)
}

export const VCR_META = { showsVcr: true }

// Opt-in guard for the change order routes: the menu hides them, but bookmarks and links still led there
export const CHANGE_ORDER_META = { changeOrder: true }

export const showsChangeOrder = (to) => !!to.meta?.changeOrder

// print-page serves both PDFs; only the VCR one is blocked
export const VCR_PRINT_META = {
  showsVcr: true,
  showsVcrParams: { page: pageToPrint.vcrPage },
}
